module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
  with (locals || {}) {
    ; __append("<div class=\"row\">\n	<div><label>Файл в формате csv</label></div>\n	<input type=\"file\" name=\"file\">\n</div>\n\n<div name=\"options\"></div>\n\n<div class=\"row\">\n	<button on-click=\"onUploadClick\" class=\"gl-primary-button\">Загрузить файл</button>\n</div>\n")
  }
  return __output.join("");

}